var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChannelPartner01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 0.75px;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "channel partner") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12.53,
    cy: 11.94,
    r: 6.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12.48,
    cy: 8.98,
    r: 1.97
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 20.61,
    cy: 1.99,
    r: 0.99
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 4.3,
    cy: 1.99,
    r: 0.99
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 20.61,
    cy: 21.74,
    r: 0.99
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 4.3,
    cy: 21.74,
    r: 0.99
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9,17.06V14.4A3.46,3.46,0,0,1,12.48,11h0a3.46,3.46,0,0,1,3.45,3.45v2.75"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.05,
    y1: 5.35,
    x2: 19.82,
    y2: 2.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 8,
    y1: 5.35,
    x2: 5.23,
    y2: 2.58
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.05,
    y1: 18.34,
    x2: 19.82,
    y2: 21.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 8,
    y1: 18.34,
    x2: 5.23,
    y2: 21.11
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannelPartner01);
export default __webpack_public_path__ + "static/media/channel_partner_01.334ee1c9e3c788af06e20b09c1dfa3e1.svg";
export { ForwardRef as ReactComponent };